const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  structuredData 
}) => {
  const baseUrl = "https://cuvantsirugaciune.ro";
  const defaultImage = "https://images.unsplash.com/photo-1617610882105-71c5d7447837?w=1200&h=630&fit=crop";

  return (
    <>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`${baseUrl}${canonicalUrl}`} />

      {/* Language and Region */}
      <meta name="language" content="ro" />
      <meta name="geo.region" content="RO" />

      {/* Open Graph Tags */}
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:url" content={`${baseUrl}${canonicalUrl}`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Cuvânt și Rugăciune" />
      <meta property="og:locale" content="ro_RO" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage || defaultImage} />

      {/* Additional SEO Meta Tags */}
      <meta name="author" content="Mircea Stanciu" />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </>
  );
};

export default SEOHead;
